import React from 'react';
import { Icon } from '../icons';
import { SocialAccount } from '../../types/api';

export const PLATFORM_NAMES: Record<string, string> = {
  bluesky: 'Bluesky', instagram: 'Instagram', facebook: 'Facebook',
  tiktok: 'TikTok', twitter: 'X', reddit: 'Reddit',
};
export function availableAccounts(accounts: SocialAccount[]): SocialAccount[] {
  return accounts.filter((a) => a.is_active && !['reddit', 'tiktok'].includes(a.platform) &&
    !a.account_name.toLowerCase().replace(/[^a-z0-9]/g, '').includes('bluewizard'));
}
export default function AccountChoices({ accounts, selected, onChange, disabled = false }: {
  accounts: SocialAccount[];
  selected: number[];
  onChange: (ids: number[]) => void;
  disabled?: boolean;
}) {
  const visible = availableAccounts(accounts);
  return <div className="calendar-accounts">
    {visible.map((account) => <label key={account.id} className="choice-chip account-toggle">
      <PlatformLogo platform={account.platform} />
      <span>{account.account_name}</span>
      <input type="checkbox" role="switch" aria-label={`${PLATFORM_NAMES[account.platform] || account.platform}: ${account.account_name}`}
        checked={selected.includes(account.id)} disabled={disabled}
        onChange={() => {
          const ids = selected.filter((id) => visible.some((a) => a.id === id));
          onChange(ids.includes(account.id) ? ids.filter((id) => id !== account.id) : [...ids, account.id]);
        }} />
      <span className="account-toggle-track" aria-hidden="true" />
    </label>)}
  </div>;
}
export function PlatformLogo({ platform }: { platform: string }) {
  const name = ['bluesky', 'instagram', 'facebook', 'twitter'].includes(platform)
    ? platform as 'bluesky' | 'instagram' | 'facebook' | 'twitter' : 'calendar';
  return <span className="platform-logo" role="img" aria-label={PLATFORM_NAMES[platform] || platform} title={PLATFORM_NAMES[platform] || platform}><Icon name={name} /></span>;
}
